import store from 'state/RootReducer';
import jwt_decode from 'jwt-decode';
import { AuthActions } from 'state/authentication/Action';
// import { refreshAccessToken } from 'shared/manager/AxiosManager';

let timer: any;
let refreshInterval: any;

let logoutOnMessage: (
    data: string | number | object,
    emitOnSelf?: boolean
) => void;
const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

const logout = (): void => {
    console.log('------IdleCheck: Idle Check file logout');
    store.dispatch(
        AuthActions.doExpirityLogout({
            isExpiritySession: false,
            isIdleCheckLogout: true,
            ExpritySessionMsg: 'Your session has expired',
        })
    );
    console.log('------IdleCheck: Idle Check file stopIdleCheck');
    // eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
    stopIdleCheck();
};

export const logoutOnIdle = (): void => {
    const { authState }: any = store.getState();
    const { isUserLoggedIn } = authState;
    if (isUserLoggedIn) {
        const logoutAfter = 30 * 60 * 1000; // 30 Mins
        // const logoutAfter = 10 * 1000; // 15 Mins
        clearTimeout(timer);
        timer = setTimeout(() => {
            console.log('----idle logout', new Date());
            logout();
        }, logoutAfter);
        console.log('----logout in ', logoutAfter);
    }
};
const logoutInMessagingBroadcast = (e: any): void => {
    logoutOnMessage(e, false);
};

const stopIdleCheck = (): void => {
    console.log('------IdleCheck: Stopping Idle Check');
    events.forEach((name) => {
        document.removeEventListener(name, logoutOnIdle, true);
        document.removeEventListener(name, logoutInMessagingBroadcast, false);
    });
    clearTimeout(timer);
    clearInterval(refreshInterval);
};

const clearRefreshInterval = (): void => {
    clearInterval(refreshInterval);
    localStorage.removeItem('isTokenRefreshing');
};

const renewAccessToken = (): void => {
    const { authState }: any = store.getState();
    const { accessToken, isUserLoggedIn } = authState;
    if (accessToken) {
        const decoded: any = jwt_decode(accessToken);
        if (decoded && isUserLoggedIn) {
            const { exp } = decoded;
            const currentTime = new Date().getTime();
            const timeToExpire = exp * 1000 - currentTime;
            if (timeToExpire > 10000) {
                console.log('refresh-triggered');
                localStorage.setItem('renewTriggered', 'yes');
                console.log('refresh token in', timeToExpire / 1000);
                clearInterval(refreshInterval);
                refreshInterval = setInterval(() => {
                    const { authState }: any = store.getState();
                    const { refreshTokenIn } = authState;
                    store.dispatch(
                        AuthActions.forceRefreshToken(refreshTokenIn + 1)
                    );

                    console.log('------IdleCheck: Going to refresh the token');
                }, timeToExpire);
            }
        }
    }
};

const startIdleCheck = (
    _logoutOnMessage: (
        data: string | number | object,
        emitOnSelf?: boolean
    ) => void
): void => {
    logoutOnMessage = _logoutOnMessage;
    console.log('------IdleCheck: Starting Idle Check');
    events.forEach((name) => {
        document.addEventListener(name, logoutOnIdle, true);
        document.addEventListener(name, logoutInMessagingBroadcast, false);
    });
    logoutOnIdle();
    renewAccessToken();
};

export {
    startIdleCheck,
    stopIdleCheck,
    renewAccessToken,
    clearRefreshInterval,
};
